export default __webpack_public_path__ + "static/media/styleguide-cards-bg3.921468e8.png";